<template>
  <div>
    <!-- 公告弹框 -->
    <el-dialog v-model="noticeDialogVisible" :title="noticeData.popup_type === 1 ? '公告' : '海报'" width="40vw"
      :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" center>
      <!-- 文本类型公告 -->
      <div v-if="noticeData.popup_type === 1" style="text-align: center; padding: 20px;">
        <p style="font-size: 16px; line-height: 1.6; white-space: pre-wrap;">{{ noticeData.popup_text }}</p>
      </div>

      <!-- 图片类型公告 -->
      <div v-else-if="noticeData.popup_type === 2" style="text-align: center;">
        <img :src="config.baseURL + '/' + noticeData.popup_poster" alt="公告海报"
          style="max-width: 100%; max-height: 500px; object-fit: contain;" @error="handleImageError" />
      </div>
      <template #footer>
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <div style="text-align: center;">
            <el-checkbox v-model="todayNoShow" size="large">
              今日不再弹出
            </el-checkbox>
          </div>
          <div style="text-align: center;">
            <el-button type="primary" @click="closeNotice">确定</el-button>
          </div>
        </div>
      </template>
    </el-dialog>

    <div class="header" v-if="isLoginPage">
      <div style="flex: 1;display: flex;justify-content: space-between;">
        <div
          style="display: flex;justify-content: end;align-items: center;position: relative;left: 10px;margin-right: 20px;">
          <img src="../public/logo.png" alt="" style="width: 200px;height: 40px;object-fit: contain;">
        </div>
        <el-menu :default-active="getActiveMenu(route.path)" class="el-menu-demo" style="flex: 1;" mode="horizontal">
          <el-menu-item index="/miniPrograms" @click="jump('/miniPrograms')">超前点播</el-menu-item>
          <el-menu-item index="kuaishou" @click="openKuaishou">快手超前</el-menu-item>
        </el-menu>
      </div>
      <div class="quitOut">
        <img v-if="userInfo.headimg" :src="config.baseURL + '/' + userInfo.headimg" alt=""
          style="width: 40px;height: 40px;border-radius: 50%;margin-right: 10px;">
        <img v-else src="../public/userheadimg.png" alt=""
          style="width: 40px;height: 40px;border-radius: 50%;margin-right: 10px;">
        {{ userInfo.nickname }}
        <el-dropdown trigger="click" style="margin-top: 5px;">
          <span class="el-dropdown-link">
            <el-icon class="el-icon--right">
              <arrow-down />
            </el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="quitOut">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <div style="margin-top: 60px">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, inject } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ArrowDown } from '@element-plus/icons-vue'
import config from '../api/config'
import { useStore } from 'vuex'
import { ElDialog, ElButton } from 'element-plus'

const store = useStore()
const http = inject("http");
const router = useRouter();
const route = useRoute();
const isLoginPage = ref(true);
const menuList = ["/miniProgramq", "/miniPrograms"];
const userInfo = ref(JSON.parse(localStorage.getItem("userInfo")) ? JSON.parse(localStorage.getItem("userInfo")) : { nickname: '', headimg: '' });

// 公告相关数据
const noticeDialogVisible = ref(false);
const noticeData = ref({
  popup_type: 0,
  popup_text: '',
  popup_poster: '',
  is_popup_show: 0
});

// 今日不再弹出选择框状态
const todayNoShow = ref(false);

const quitOut = function () {
  localStorage.removeItem("token");
  localStorage.setItem("userInfo", JSON.stringify({ nickname: '', headimg: '' }));
  router.push("/login");
};

const getNotice = function () {
  if (route.path !== '/miniPrograms/home') {
    return;
  }

  http.get('api/Episode/popupConfig').then(res => {
    if (res.code == 0) {
      noticeData.value = res.data

      if (noticeData.value.is_popup_show == 1 && !isTodayPopupDisabled()) {
        noticeDialogVisible.value = true;
      }
    }
  }).catch(error => {
  });
};

const closeNotice = function () {
  if (todayNoShow.value) {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;

    localStorage.setItem('notice_disabled_today', dateString);
  }
  noticeDialogVisible.value = false;
};

const isTodayPopupDisabled = function () {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  const todayString = `${year}-${month}-${day}`;

  const disabledDate = localStorage.getItem('notice_disabled_today');
  return disabledDate === todayString;
};

const handleImageError = function (event) {
  event.target.style.display = 'none';
};

const debounce = (fn, delay) => {
  let timer
  return (...args) => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 200);
    super(callback);
  }
}
watch(
  () => store.state,
  (newPath) => {
    const localUserInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    userInfo.value = {
      headimg: localUserInfo.headimg || newPath.headimg,
      nickname: localUserInfo.nickname || newPath.nickname
    };
  },
  { deep: true }
);
onMounted(() => {
  isLoginPage.value = !["/login", "/", "/agreement", "/privacy"].includes(route.path);
  userInfo.value = JSON.parse(localStorage.getItem("userInfo")) ? JSON.parse(localStorage.getItem("userInfo")) : { nickname: '', headimg: '' };
  getNotice()
});
watch(
  () => route.path,
  (newPath) => {
    isLoginPage.value = !["/login", "/", "/agreement", "/privacy"].includes(newPath);

    if (newPath === '/miniPrograms/home') {
      getNotice();
    }
  }
);
const jump = function (url) {
  router.push(url);
};
const openKuaishou = function () {
  window.open('https://cp.longyuteam.com/', '_blank', 'noopener,noreferrer');
};
const getActiveMenu = function (val) {
  for (const item of menuList) {
    if (val.startsWith(item)) {
      return item;
    }
  }
  return "/index";
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

li {
  list-style: none;
}

.header {
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 60px;
  position: fixed;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  top: 0;
  background-color: #fff;
  z-index: 999;
}

.header>div:nth-child(1) {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  width: 1800px;
  margin: 0 auto;
}

.header>div>.el-menu {
  flex: 1;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.quitOut {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.header ::v-deep .example-showcase .el-dropdown-link {
  cursor: pointer;
  color: var(--el-color-primary);
  display: flex;
  align-items: center;
}

.cursor_pointer {
  cursor: pointer;
}
</style>
